import Cookies from "js-cookie";
import React, { createContext, useState } from "react";

import { getToken } from "../components/api/auth";
import { safeJsonParse } from "../components/global/JsonHelper";

const DataContext = createContext({});

export const DataProvider = ({ children }) => {
  const [accessToken, setAccessToken] = useState(() => getToken());
  const [isLoading, setLoading] = useState(true);

  const [loggedInUser, setLoggedInUser] = useState();

  const [caseManagerPk, setCaseManagerPk] = useState(
    !Cookies.get("pnCmPk") ? null : safeJsonParse(Cookies.get("pnCmPk"))
  );
  const [selectedClient, setSelectedClient] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(null);

  //All used for the map/assign provider page
  const [selectedProvider, setSelectedProvider] = useState("");
  const [activeProvider, setActiveProvider] = useState();
  const [activeClientMap, setActiveClientMap] = useState(null);
  const [altAddress, getAltAddress] = useState(null);
  const [clientCoords, getClientCoords] = useState();
  const [nearestProviders, getNearestProviders] = useState();
  const [newNonNetProv, getNewNonNetProv] = useState();
  //End of  assign prov context

  const [trigger, setTrigger] = useState(false);
  const [casePk, getCasePk] = useState();
  const [searchProvPk, setSearchProvPk] = useState("");
  const [activeBills, setActiveBills] = useState();
  const [lostCodes, setLostCodes] = useState([]);
  const [activePath, setActivePath] = useState("search");
  const [q4LawfirmPath, setQ4LawfirmPath] = useState("liabilityRequested");
  const [tabTitle, setTabTitle] = useState();
  const [prevCL, setPrevCL] = useState([]);
  const [activeLawfirm, setActiveLawfirm] = useState("");
  const [lawFirmLink, setLawFirmLink] = useState("");
  const [userType, setUserType] = useState("");
  const [patchNotif, setPatchNotifs] = useState();
  const [refreshDialog, setRefreshDialog] = useState(false);
  const [currentPatchV, setCurrentPatchV] = useState();
  const [needsUpdate, setNeedsUpdate] = useState(false);
  const [selectedLead, setSelectedLead] = useState("");
  const [caseCountPk, setCaseCountPk] = useState("");
  //below state used for action items routing for admins
  const [activeUsers, setActiveUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedLawFirms, setSelectedLawFirms] = useState([]);
  const [activeLawFirms, setActiveLawFirms] = useState([]);
  const [selectedCases, setSelectedCases] = useState([]);
  const [activeCases, setActiveCases] = useState([]);
  const [selectedProviders, setSelectedProviders] = useState([]);
  const [activeProviders, setActiveProviders] = useState([]);
  const [userRoles, setUserRoles] = useState("");
  const [userPaths, setUserPaths] = useState([]);
  const [dashCompLimit, setDashCompLimit] = useState(10);
  const [errorMessage, setErrorMessage] = useState("");
  const [languageObj, setLanguageObj] = useState("");

  const [dashboardV, setDashboardV] = useState(
    !Cookies.get("dashVersion") ? "new" : Cookies.get("dashVersion")
  );
  const [stopSse, setStopSse] = useState(() => () => {});

  return (
    <DataContext.Provider
      value={{
        selectedClient,
        setSelectedClient,
        isLoggedIn,
        setIsLoggedIn,
        selectedProvider,
        setSelectedProvider,
        caseManagerPk,
        setCaseManagerPk,
        accessToken,
        setAccessToken,
        activeClientMap,
        setActiveClientMap,
        clientCoords,
        getClientCoords,
        activeProvider,
        setActiveProvider,
        nearestProviders,
        getNearestProviders,
        newNonNetProv,
        getNewNonNetProv,
        isLoading,
        setLoading,
        altAddress,
        getAltAddress,
        trigger,
        setTrigger,
        casePk,
        getCasePk,
        searchProvPk,
        setSearchProvPk,
        lostCodes,
        setLostCodes,
        activeBills,
        setActiveBills,
        activePath,
        setActivePath,
        q4LawfirmPath,
        setQ4LawfirmPath,
        tabTitle,
        setTabTitle,
        prevCL,
        setPrevCL,
        activeLawfirm,
        setActiveLawfirm,
        lawFirmLink,
        setLawFirmLink,
        userType,
        setUserType,
        patchNotif,
        setPatchNotifs,
        refreshDialog,
        setRefreshDialog,
        currentPatchV,
        setCurrentPatchV,
        needsUpdate,
        setNeedsUpdate,
        dashboardV,
        setDashboardV,
        selectedLead,
        setSelectedLead,
        caseCountPk,
        setCaseCountPk,
        activeUsers,
        setActiveUsers,
        selectedUsers,
        setSelectedUsers,
        selectedLawFirms,
        setSelectedLawFirms,
        activeLawFirms,
        setActiveLawFirms,
        selectedCases,
        setSelectedCases,
        activeCases,
        setActiveCases,
        selectedProviders,
        setSelectedProviders,
        activeProviders,
        setActiveProviders,
        userRoles,
        setUserRoles,
        userPaths,
        setUserPaths,
        dashCompLimit,
        setDashCompLimit,
        errorMessage,
        setErrorMessage,
        loggedInUser,
        setLoggedInUser,
        languageObj,
        setLanguageObj,
        stopSse,
        setStopSse,
      }}
    >
      {children}
    </DataContext.Provider>
  );
};

export default DataContext;
